<template>
  <div class="newsList">
    <div class="box">
      <div style="text-align: center ;padding:2% ">
        <el-button @click="show=!show">上传word/pdf/excel</el-button>
      </div>
      <el-upload
          class="upload-demo"
          drag
          action="/api3/FileUpload/addWordEtc"
          v-show="show"
          multiple
      >

        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
          <em>点击上传文件</em>
        </div>
        <template #tip>
          <div class="el-upload__tip">
            files with a size less than 500MB
          </div>
        </template>
      </el-upload>
      <div class="contentrows_box">
        <div class="contentrows">
          <div v-if="news.length === 0">
            <span style="color: black;font-size:10px;">暂无数据</span>
          </div>
          <div class="row_box" v-for="(item,index) in news" :key="index">
            <div class="row">
              <div class="row_date">
                <div class="row_date_left">{{item.day}}</div>
                <div class="row_date_right">
                  <div class="row_date_month">{{item.month}}</div>
                  <div class="row_date_year">{{item.year}}</div>
                </div>
              </div>
              <div class="row_content">
                <div class="row_title" style="text-align: center" @click="showAnnounce(item)">{{item.name}}</div>
<!--                <div class="row_name">{{item.uniName}}</div>-->

              </div>
<!--              <el-button type="primary" @click="FileDetailsShow(item)" >详情</el-button>-->
              <el-button type="primary" @click="DeleteFile(item)" >删除</el-button>
            </div>
          </div>
        </div>
<!--        <div class="page" v-if="news.length > 0">-->
<!--          <el-pagination-->
<!--              @size-change="handleSizeChange"-->
<!--              @current-change="handleCurrentChange"-->
<!--              :page-sizes="[2, 4, 6, 8,10]"-->
<!--              :page-size="pageSize"-->
<!--              layout="sizes, prev, pager, next"-->
<!--              background-->
<!--              :total="totalNum">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>

    </div>
  </div>
</template>
<script  >
import time from "@/core/time";

const Base64 = require('js-base64').Base64
export default {
  name: "FileEdit",
  data(){
    return {
      totalNum:0,pageNum:1,pageSize:4,
      news:[],
      name:'',
      show:false,
      fileType:'',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    }
  },
  created() {
    this.newsSelect();
  },
  mounted() {
  },
  methods:{
    DeleteFile(value){
      let url='/FileUpload/deleteFile'
      this.$request.post(url,value.id).then(data=>{
        this.$msg.warning('删除成功!')
      })
      location.reload();
    },
    FileDetailsShow(value) {
      this.$router.push({
        path: '/fileDetailsShow',
        query: {
          id: value.id,
        }
      })
    },
    newsSelect(){
      let data = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
      };
      console.log('==============',data);
      let url = '/FileUpload/selectDownloadFile';
      this.$request.post(url,data).then(data => {
        this.news = data.obj.list;
        console.log(this.news,"jfiwe")
        debugger
        //debugger
        this.totalNum = data.obj.total;
        for(let item of this.news){
          item.year=item.createdDate.substring(0,4);
          item.month=item.createdDate.substring(5,7);
          item.day=item.createdDate.substring(8,10);
          // this.$set(item,"year",item.createdDate.substring(0,4));
          // this.$set(item,"month",item.createdDate.substring(5,7));
          // this.$set(item,"day",item.createdDate.substring(8,10));
          item.createdDate = time.formateDate(item.createdDate);
        }
      })
    },
    editPage(value){
      this.$router.push({
        path:'/requirementEdit',
        query:{
          id:value.id,

        }
      })
    },

  }
}
</script>

<style scoped lang="less">
.newsList{
  width: 100%;
  height: 80%;
  background: white;
  .contentrows_box{
    height: 55%;
    border-radius:20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;
    .contentrows{
      margin:auto;
      width:860px;
      padding-top: 8px;
      .row_box{
        width:90%
      }
      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;
        .row_date{
          display: flex;
          float: left;
          width: 82px;
          .row_date_left{
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }
          .row_date_right{
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;
            .row_date_month{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
            .row_date_year{
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
        .row_content{
          margin-top: 40px;
          line-height: 40px;
          height: 30px;
          padding-left: 20px;
          margin-left: 10px;
          width: 400px;
          float: left;
          border-left: 6px solid #CDD9E9;
          .row_title {
            overflow: hidden;
            width: 400px;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow:hidden;
            float: left;
          }
          .row_title:hover{
            cursor: pointer;
          }
          .row_name{
            font-size: 13px;
            width: 200px;
            color: #a8a8ac;
            float: right;
            text-align: right;
          }
        }
        .el-button{

          background: #3A63B3;
          //background: red;
          color: red;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius:0;
          float: right;
        }
      }

    }
    .page{
      height: 100px;
      width: 860px;
      margin:auto;
      position: relative;
      .el-pager{
        li{
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }
        li:not(.disabled).active{
          background-color: #3A62FE;
          color: white;
        }
        li:hover {
          color: #3A62FE;
        }
      }
      .btn-prev{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }
      .btn-next{
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }
      .el-pagination{
        position: absolute;
        bottom: 30px;
        right: 0;
        .el-pagination__sizes{
          float: right;
          .el-input__inner{
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}
.box{
  height:600px;
  padding:2% 20%;
  text-align: center;
  .log_img {
    width: 100%;
    //height: 100%;
    // display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    margin-top: 35px;
    text-align: -webkit-center;
    //float: left;

    .el-carousel__container {
      width: 100%;
      height: 100%;
    }

    img:hover {
      cursor: pointer;
    }
  }
}
</style>
